import React from 'react';
import PropTypes from 'prop-types';
import './toastAdvertiser.scss';

const ToastAdvertiser = ({ imgSrc, text, imgBgColor, descriptionContent }) => (
  <div className="a-toast-advertiser">
    <div
      className="a-toast-advertiser__img"
      style={{ backgroundColor: imgBgColor }}
    >
      <img
        src={imgSrc}
        alt={imgSrc.includes('icon-alert.svg') ? 'Error' : 'icono'}
      />
    </div>
    <div className="a-toast-advertiser__description">
      <p>{text}</p>
      {descriptionContent && descriptionContent}
    </div>
  </div>
);

ToastAdvertiser.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  imgBgColor: PropTypes.string,
  descriptionContent: PropTypes.any
};

ToastAdvertiser.defaultProps = {
  imgBgColor: '#2B91FF'
};

export default ToastAdvertiser;
